module.exports = __webpack_public_path__ + "img/Overflowing_Cup.d2471eee.png";